import { defineStore } from "pinia";
import { NewsService } from '../services/news.service';
import { isSwedishLocale } from "../services/locale.service";

export const useNewsStore = defineStore('news', {
  state: () => {
    return {
      news: [],
      latest: []
    }
  },

  getters: {
    allExcept(state) {
      const slugPropertyByLang = { 'sv': 'slug', 'en': 'slug_eng' };
      let slugProperty = isSwedishLocale() ? 'slug' : 'slug_eng';

      return (slug, previewLanguage) => {
        if (previewLanguage) {
          slugProperty = slugPropertyByLang[previewLanguage];
        }
        return state.news.filter(item => item[slugProperty] !== slug);
      }
    },

    getBySlug(state) {
      const slugPropertyByLang = { 'sv': 'slug', 'en': 'slug_eng' };
      let slugProperty = isSwedishLocale() ? 'slug' : 'slug_eng';
      let invertedSlugProperty = !isSwedishLocale() ? 'slug' : 'slug_eng';

      return (slug, previewLanguage) => {
        if (previewLanguage) {
          slugProperty = slugPropertyByLang[previewLanguage];
        }
        const newsItem = state.news.find(item => item[slugProperty] === slug);
        return newsItem || state.news.find(item => item[invertedSlugProperty] === slug);
      }
    }
  },

  actions: {
    async loadLatest() {
      if (this.latest.length > 0) {
        return;
      }
      this.latest = await (new NewsService()).loadLatest();
    },

    async forceReloadLatest() {
      this.latest = await (new NewsService()).loadLatest();
    },

    async loadAll(preview) {
      if (this.news.length > 0 && !preview) {
        return;
      }

      this.news = await (new NewsService()).load(preview);
    }
  }
})